import { useState, useEffect, useRef } from 'react'

const usePortalPosition = ({ showSuggestions, containerRef }) => {
  const dropdownContainerRef = useRef(null)
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 })

  useEffect(() => {
    if (!showSuggestions || !containerRef.current) {
      return
    }

    const updatePosition = () => {
      const rect = containerRef.current.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

      // Calculate position with actual dropdown height if available, otherwise use estimated height
      const dropdownHeight = dropdownContainerRef.current?.getBoundingClientRect().height || 200

      setPosition({
        top: rect.top + scrollTop - dropdownHeight - 20,
        left: rect.left + scrollLeft,
        width: rect.width,
      })
    }

    // Set initial position immediately
    updatePosition()

    // Recalculate after dropdown is rendered with requestAnimationFrame
    requestAnimationFrame(updatePosition)

    // Add event listeners for scroll and resize
    window.addEventListener('scroll', updatePosition, true)
    window.addEventListener('resize', updatePosition)

    // Cleanup event listeners
    return () => {
      window.removeEventListener('scroll', updatePosition, true)
      window.removeEventListener('resize', updatePosition)
    }
  }, [showSuggestions, containerRef])

  return {
    position,
    dropdownContainerRef,
  }
}

export default usePortalPosition
